import { useModuleBEM } from "@b2bportal/core-themes";
import clsx from "clsx";
import styles from "./styles.module.scss";

export interface RequiredBadgeProps {
  className?: string;
  label?: string;
}

export const RequiredBadge = ({
  className,
  label = "Required",
}: RequiredBadgeProps): JSX.Element => {
  const [block, cn] = useModuleBEM(styles, "RequiredBadge");

  return (
    <span className={clsx(block, className)} role="img" aria-label={label}>
      <span className={cn("label")} aria-hidden="true">
        {label}
      </span>
    </span>
  );
};
